import { useState, useEffect } from "react"
import axios from "axios"

const useFetch = (url) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    setLoading(true)
    setData(null)
    setError(null)
    axios
      .get(url, { headers: { "Content-Type": "application/json" } })
      .then((res) => {
        setLoading(false)
        setData(res.data)
        //console.log(res.data)
      })
      .catch((err) => {
        setLoading(false)
        setError(err)
        console.error(error)
      })
  }, [url, error])

  return {
    data,
    loading,
    error,
  }
}

export default useFetch
